import SangerRow from './SangerRow';
import { useEffect, useState, memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { useFormik, ErrorMessage, FormikProvider, yupToFormErrors } from 'formik';
import * as Yup from 'yup';
import PrimerRow from './PrimerRow';
import { dark } from '@material-ui/core/styles/createPalette';
import {DebounceInput} from 'react-debounce-input';
import Grid from '@material-ui/core/Grid';
import useWindowSize from '../../Reusable/windowSize';
import axios from 'axios';
import ExcelUploadPopup from '../ExcelUploadPopup';
import SangerRowComponent from './SangerRowComponent';
import SangerPrimerRowComponent from './SangerPrimerRowComponent';
import SangerLabPrimerPopup from "./SangerLabPrimerPopup";
import LoadingButton from '@mui/lab/LoadingButton';
import RotateLoader from 'react-spinners/RotateLoader';
import ErrorFormPopup from '../ErrorFormPopup';
import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@mui/material/Backdrop';
import { useSnackbar } from 'notistack';
import SangerInfoForm from './SangerInfoForm';


import { hashString, stringToColour, ColorLuminance } from '../../Reusable/Color';
const {v4 : uuidv4} = require('uuid')

const primerColors = new Map();
//do this in a for loop
for (let i = 0; i <= 96; i++) {
    var stringCode = 'MECL';
    for (let j = 0; j < 6; j++) {
      stringCode = stringCode.concat(i);
    }
    stringCode = stringCode.concat('SANGER');
    let result = hashString(stringCode);
    var color = stringToColour(stringCode);
    const darkerColor = ColorLuminance(color, 0.5);
    primerColors.set(i.toString(), darkerColor);
}

export const strReturnOnlyNumbersPositive = (str) => {
  var val = parseInt(str.replace(/[^0-9]/g, ''));
  if (isNaN(val)) {
    val = 0;
  }
  if ( val < 0) {
    val = 0;
  }
  return val;
}

const API_ENDPOINT =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_API_ENDPOINT_PROD
    : process.env.REACT_APP_API_ENDPOINT_DEV

const Sanger = () => {

  useEffect(() => {
    axios
      .get(API_ENDPOINT + '/user/new')
      .then((res) => {
        if (res.status === 200) {
          //Do nothing
        }
      })
      .catch(function (error) {
        if (error.response && error.response.status === 302) {
          navigate('/profile', { replace: true });
        }
      });
  }, []);


  const [width, height] = useWindowSize();
  const navigate = useNavigate();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const useStyles = makeStyles({
    submitButton: {
      fontSize: '10rem',    // Adjust as necessary
      height: '100px',     // Adjust as necessary
      width: '300px',      // Adjust as necessary
      // ... Any other styles you want
    },
  });
  const classes = useStyles();

  const sampleData = {
    id: uuidv4(),
    sampleName: '',
    primerRowList: [],
    premixed: false,
    concVal: '',
    readLen: '',
    vol: '',
    type: '',
    template: '',
    touched: new Array(7).fill(false)
  };

  const primerData = {
    // id: [...new Array(5)].map(() => uuidv4()),
    id: uuidv4(),
    primerName: '',
    vol: '',
    count: 0,
    labPrimer: false,
    labPrimerId: 0,
    touched: new Array(2).fill(false)
  };

  const SangerValidationSchema = Yup.object().shape({
    samples: Yup.array()
    .of(
      Yup.object({
        sampleName: Yup.string()
          .max(70, 'Name should be 70 characters or less')
          .required('Sample Name is required'),
        primerRowList: Yup.array()
        .required('Primers must be selected')
        .test({
          name: 'min',
          exclusive: false,
          params: { },
          message: `At least one primer is required or sample must be premixed`,
          test: function (value) {
              // You can access the price field with `this.parent`.
            return value.length >= (this.parent.premixed ? 0 : 1);
          },
        }),
        premixed: Yup.bool()
        .required('Checkebox must be inputted'),
        concVal: Yup.number()
          .typeError('Concentration must be a number')
          .min(1, 'Concentration should be greater than 1 ng')
          .required('Concentration is required'),
        readLen: Yup.number()
          .typeError('Read length must be a number')
          .min(0, 'Read Length cannot be lower than 0 bp')
          .max(800, 'Read Length should be no greater than 800 bp')
          .required('Read Length is required'),
        vol: Yup.number()
          .typeError('Volume must be a number')
          .required('Volume is required')
          // .nullable(true)
          .test({
            name: 'min',
            exclusive: false,
            params: { },
            message: "Volume must be be at least 10 µl or 10 µl per primer declared",
            test: function (value) {
                // You can access the price field with `this.parent`.
                var val = this.parent.primerRowList.length == 0 ? 1 : this.parent.primerRowList.length;
                return value >= parseFloat(val * 10)
            },
          }),
          type: Yup.string()
          .required("A Type must be picked"),
          template: Yup.string()
          .required("A Template must be picked")
      })
    ),
    primerMapToList: Yup.array()
    .of(
      Yup.object({
        key: Yup.number(),
        count: Yup.number()
          .min(1, "Primer must be used at least once, otherwise delete the entry"),
        labPrimer: Yup.bool(),
        labPrimerId: Yup.number().when('labPrimer', {
          is: true,
          then: Yup.number()
            .required()
        }),
        primerName: Yup.string()
          .min(5, "Name should be 5 characters or greater")
          .max(50, 'Name should be 50 characters or less')
          .required('Primer name is required')
          .test(
            'unique-primerName', 
            'Primer name must be unique',
            function (primerName) {
              const { parent } = this;
              // console.log(parent);
              // console.log(primerMapToList);
              const key = parent.key;
              const duplicate = primerMapToList.filter(item => item.primerName === primerName && Number(item.key) !== key);
              // console.log(duplicate);
              return duplicate.length === 0;
            }
          ),
          vol: Yup.mixed().when('labPrimer', {
            is: false, // If labPrimer is false
            then: Yup.number()
                .required("Volume is required")
                .typeError('Volume must be a number')
                .nullable(true)
                .test({
                    name: 'min',
                    exclusive: false,
                    params: {},
                    message: `Volume must be be at least 5 ul every time it's used in a sample`,
                    test: function (value) {
                        // You can access the price field with `this.parent`.
                        return value >= parseFloat(this.parent.count * 5);
                    },
                }),
            otherwise: Yup.mixed(),
        }),
      })  
    )
  });
  
  

  const [samples, setSamples] = useState([
    {
      id: uuidv4(),
      sampleName: '',
      primerRowList: [],
      premixed: false,
      concVal: '',
      readLen: '',
      vol: '',
      type: '',
      template: '',
      touched: new Array(7).fill(false),
    },
  ]);

  const [submitShowError, setSubmitShowError] = useState(false);
  const [showAllErrors, setShowAllErrors] = useState(true);

  const primerMap = new Map();
  const [primers, setPrimers] = useState(
    primerMap
  );

  const labPrimerIdsMap = new Map();
  const [pickedLabPrimersMap, setPickedLabPrimersMap] = useState(labPrimerIdsMap);

  const [primerMapToList, setPrimerMapToList] = useState([]);
  const [reactCount, setReactCount] = useState(0)
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoadingForm, setIsLoadingForm] = useState(true);
  const [errorPopup, setErrorPopup] = useState(false);
  
  const handleErrorPopup = async () => {
    const errors = await formik.validateForm();
    setSubmitShowError(true)
    if (Object.keys(errors).length > 0) {
        // alert("There are validation errors!");
        setErrorPopup(true);
    } else {
        formik.submitForm();
    }
};

  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    validateOnChange: true,
    validateOnBlur: true,
    initialValues: {samples, primerMapToList},
    validationSchema: SangerValidationSchema,
    onSubmit: async (values, errors) => {
        setIsLoadingForm(true);
        try {
          const res = await axios({
            method: 'post',
            url: API_ENDPOINT + '/upload/clientExcel',
            data: {samples: samples, primers: Object.fromEntries(primers)},
            params: {
              orderType: 'sanger'
            }
          });
          if (res.status == 200) {
            navigate('/Drop_off_code', { state: { dropOffCode: res.data.dropOffCode } });
          }
          console.log(res)
        } catch (error) {
          console.log("ALERT ERROR");
          console.log(error);
          alert(JSON.stringify("Error. You have either reached the maximum limit of 5 orders or an issue has occurred. Please check your orders and drop them off. Otherwise, contact us if" + 
          " the issue persists"));
        }
        setIsLoadingForm(false);
    },
  })

  const keyList = Array.from(primers.keys());
  useEffect(() => {
    var primerMapToListTemp = [];
    for (let i = 0; i < keyList.length; i++) {
      primerMapToListTemp.push({
        key: keyList[i],
        primerName: primers.get(keyList[i]) ? primers.get(keyList[i]).primerName : "",
        vol: primers.get(keyList[i]) ? parseInt(primers.get(keyList[i]).vol) : 0,
        count: primers.get(keyList[i]) ? primers.get(keyList[i]).count : 0,
        labPrimer: primers.get(keyList[i]) ? primers.get(keyList[i]).labPrimer : false,
        labPrimerId: primers.get(keyList[i]) ? primers.get(keyList[i]).labPrimerId : 0
      })
    }
    setPrimerMapToList(primerMapToListTemp);
  },[primers, reactCount])

  // for (let i = 0; i < keyList.length; i++) {
  //   primerMapToList.push({
  //     key: keyList[i],
  //     primerName: primers.get(keyList[i]) ? primers.get(keyList[i]).primerName : "",
  //     vol: primers.get(keyList[i]) ? parseInt(primers.get(keyList[i]).vol) : 0,
  //     count: primers.get(keyList[i]) ? primers.get(keyList[i]).count : 0,
  //   })
  // }

  async function updateSangerForm () {
    var res = await axios({
      url: API_ENDPOINT + '/orderForm/sanger',
      method: 'POST',
      data: {primers: Object.fromEntries(primers), samples: samples}
    })
  }

  async function loadSangerForm () {
    var res = await axios({
      url: API_ENDPOINT + '/orderForm/sanger',
      method: 'GET',
    })
    if (res.status == 200) {
      var newPrimersKeys = Object.keys(res.data.primers[0]);
      var currPrimerMap = res.data.primers[0];
      var newPrimerMap = new Map();
      for (let primerKey in newPrimersKeys) {
        newPrimerMap.set(String(newPrimersKeys[primerKey]), currPrimerMap[newPrimersKeys[primerKey]])
      }
      setPrimers(primers => new Map(newPrimerMap));
      setSamples(res.data.samples);
      setIsLoadingForm(false)
      if (res.data.samples.length !=0 || newPrimersKeys.length != 0) {
        enqueueSnackbar("Your last saved data was loaded!", { variant: 'info' });
      }
    }
  }

  useEffect(() => {
    loadSangerForm();
  }, [])

  async function uploadExcelFile (selectedFile) {
    const formData = new FormData();
    formData.append('clientSangerExcelUploadBody', selectedFile);
    var res = await axios({
      url: API_ENDPOINT + '/sampleList/clientSangerExcel',
      method: 'POST',
      data: formData
    })
    if (res.status == 200) {
      const newPrimers = new Map(Object.entries(res.data.primers.primerData));
      const newSamples = res.data.samples.sampleData;
      setPrimers(primers => new Map(newPrimers));
      setSamples(newSamples);
      setSubmitShowError(true);
    }
    return res;
  }

  useEffect(() => {
    updateSangerForm();
    updateLabPrimerMapFromPrimers();
  }, [primerMapToList, samples])

  useEffect(() => {
    var reactCountNum = 0;
    var primerCount = new Map();
    for (let i = 0; i < samples.length; i++) {
      reactCountNum += samples[i].primerRowList.length;
      if (samples[i].premixed) {
        reactCountNum += 1
      }
      for (let j = 0; j < samples[i].primerRowList.length; j++) {
        var currentKey = samples[i].primerRowList[j];
        if (primerCount.get(currentKey) === undefined) {
          primerCount.set(currentKey, 1);
        } else {
          primerCount.set(currentKey, primerCount.get(currentKey) + 1);
        }
      }
    }
    var primersCopy = primers;
    Array.from(primersCopy.keys()).forEach(key => {
      var tempData = primersCopy.get(key);
      var count = 0
      if (primerCount.has(key)) {
       count = primerCount.get(key);
      }
      tempData = {...tempData, ...{count: count}};
      primersCopy.set(key, tempData);
    });
    setPrimers(primersCopy);
    setReactCount(reactCountNum)
    // formik.validateForm();
  },
  [primerMapToList, samples]);

  const addNewSample = () => {
    //assume you converted data to right format/structure

    const newSamples = [...samples];
    newSamples.push(sampleData);
    setSamples(newSamples);
    // formik.validateForm();
  };

  const addNewSampleIndex = (rowIndex) => {
    //assume you converted data to right format/structure
    const newSamples = [...samples];
    newSamples.splice(rowIndex, 0, sampleData);
    setSamples(newSamples);
    // formik.validateForm();
  };

  const updateSample = (updatedField, id) => {
    console.log(updatedField);
    setSamples((prevSamples) =>
    prevSamples.map((item) =>
      item.id === id
        ? { ...item, ...updatedField }// Create a new object with the updated value
        : item // Leave the item unchanged if it's not the one to update
    )
  );
  };

  // const removeSample = (index) => {
  //   if (samples.length !== 1) {
  //     const newSamples = [...samples];
  //     newSamples.splice(index, 1);
  //     setSamples(newSamples);
  //   }
  //   // formik.validateForm();
  // };

  const removeSample = (id) => {
    setSamples((prevSamples) => prevSamples.filter((item) => item.id !== id));
  };

  // primer manipulations
  const addNewPrimer = () => {
    var index = 0;
    while (true) {
      if (!primers.has(index.toString())) {
        updatePrimerMap(index.toString(), primerData)
        break;
      }
      index+= 1;
    }
    // formik.validateForm();
  };

  const updateLabPrimerMapFromPrimers = () => {
    // console.log("UPDAT EPRIMER LAB MAP BROO")
    // console.log(primerMapToList);
    setPickedLabPrimersMap(new Map());
    primerMapToList.map(eachPrimer => {
      if (eachPrimer.labPrimerId) {
        // console.log(eachPrimer);
        // console.log('each PRIMERO')
        updateLabPrimerMap(eachPrimer.labPrimerId);
      }
    })
  }

  const addNewLabPrimer = (data) => {
    var index = 0;
    while (true) {
      if (!primers.has(index.toString())) {
        data.map(eachPrimerData => {
          eachPrimerData['labPrimerId'] = eachPrimerData.primerID;
          eachPrimerData['labPrimer'] = true;
          // console.log(eachPrimerData);
          var primerDataCopy = {...primerData, ...eachPrimerData};
          updatePrimerMap(index.toString(), primerDataCopy);
          index+= 1;
          if (!pickedLabPrimersMap.has(eachPrimerData.primerID)) {
            updateLabPrimerMap(eachPrimerData.primerID);
          }
        })
        break;
      }
      index+= 1;
    }
  }

  const updatePrimerMap = (key, valueObj) => {
    setPrimers(primers => {
      const currentObj = primers.get(key) || {};
      const updatedObj = { ...currentObj, ...valueObj };
      return new Map(primers.set(key, updatedObj));
    });
  }

  const updateLabPrimerMap = (key) => {
    setPickedLabPrimersMap(pickedLabPrimersMap => {
      return new Map(pickedLabPrimersMap.set(key, true));
    });
  }
  
  // console.log(primers);
  const removePrimer = (key) => {
    // if (primers.size !== 1) {
    const currPrimer = primers.get(key);
    // console.log(currPrimer)
    if (currPrimer.labPrimer) {
      // console.log(currPrimer.labPrimerId);
      const pickedLabPrimersMapCopy = new Map(pickedLabPrimersMap);
      pickedLabPrimersMapCopy.delete(currPrimer.labPrimerId);
      setPickedLabPrimersMap(pickedLabPrimersMapCopy);
    }
    primers.delete(key);
    setPrimers(new Map(primers));
    // }
    const newSamples = [...samples];
    for (let i = 0; i < newSamples.length; i++) {
      var primerListInSample = newSamples[i].primerRowList;
      const index = primerListInSample.indexOf(key);
      if (index > -1) { // only splice array when item is found
        primerListInSample.splice(index, 1); // 2nd parameter means remove one item only
        newSamples[i].primerRowList = primerListInSample
      }
    }
    setSamples(newSamples);
    // formik.validateForm();
  };

  // console.log(samples);
  // console.log(primers);
  // console.log(primerMapToList)
  // console.log(formik)
  // console.log(samples)

  return (
    <div>
       <SangerInfoForm/>
      <Backdrop
        sx={{ color: '#fff', zIndex: 1}}
        open={isLoadingForm}
      >
        <RotateLoader/>
      </Backdrop>
      <ErrorFormPopup
      open={errorPopup}
      handler={setErrorPopup}
      samples={formik.errors.samples}
      primerList={formik.errors.primerMapToList}
      primerData={primerMapToList}
      />
      {/* Put warning here in case screen size is too small */}
      <Grid container spacing={0}>
      <Grid item xs={12} style={{marginLeft: 25}}>
        <h3>
        Your current reaction count: {reactCount}
        </h3>
      </Grid>
      <Grid item xs={2}
      style={{marginBottom: 0, paddingLeft: 50}}>
      <Button
      variant="contained"
      color="primary"
      style={{}}
      onClick={() => {
        if (showAllErrors == false) {
          setSubmitShowError(true);
        }
        setShowAllErrors(!showAllErrors)
      }}
      >
        {showAllErrors ? <>
        Hide Errors
        </> : <>
        Show all errors
        </>}
      </Button>
      </Grid>
      <Grid item xs={2}>
      <ExcelUploadPopup
      uploadExcelFile={uploadExcelFile}
      formType ={'sanger'}
      />
      </Grid>
      <Grid item xs={2}>
      <Button
      variant="contained"
      color="primary"
      onClick={
        () => {
          setSamples([]);
          setPrimers(primers => new Map());
        }
      }
      >
        Clear Form
      </Button>
      </Grid>
      <text style={{marginLeft: 10}}>
      PM stands for Premixed
      </text>
      <Grid spacing={0} container
  direction="row"
  // alignItems="center"
  justifyContent="center"
  xs={12}
  >
      <Grid container spacing={0} md={12} lg={9} style={{overflowX: 'auto'}}>
        <div style={{minWidth: 1075}}>
      <h1 style={{fontSize: 32, marginBottom: 0 }}>
        Sanger Sequencing Samples
      </h1>
      <br></br>
      <Grid container columns={25} >
      <Grid item xs={1} style={{fontSize: 14, marginLeft: 15, fontWeight: 'bolder'}}>
            Well
          </Grid>
        <Grid item xs={3} style={{fontSize: 14, marginLeft: -40, fontWeight: 'bolder'}}>
            Sample Name
          </Grid>
          <Grid item xs={1} style={{fontSize: 14, marginLeft: -130, fontWeight: 'bolder'}}>
            Primers
          </Grid>
          <Grid item xs={1} style={{fontSize: 14, marginLeft: 85, fontWeight: 'bolder'}}>
            PM
          </Grid>
          <Grid item xs={1} style={{fontSize: 14, marginLeft: -50, fontWeight: 'bolder'}}>
            Concentration
          </Grid>
          <Grid item xs={1} style={{fontSize: 14, marginLeft: 20, fontWeight: 'bolder'}}>
            Read Len
          </Grid>
          <Grid item xs={1} style={{fontSize: 14, marginLeft: -10, fontWeight: 'bolder'}}>
            Vol
          </Grid>
          <Grid item xs={1} style={{fontSize: 14, marginLeft: -25, fontWeight: 'bolder'}}>
            Type
          </Grid>
          <Grid item xs={3} style={{fontSize: 14, marginLeft: 45, fontWeight: 'bolder'}}>
            Desired Template
          </Grid>
        </Grid>
              {samples.map((data, i) => {
          return (
            <SangerRowComponent 
            key={data.id}
            id={data.id}
            data={data}
            updateSample={updateSample}
            index={i}
            primers={primers}
            primerColors={primerColors}
            primerMapToList={primerMapToList}
            removeSample={removeSample}
            addNewSampleIndex={addNewSampleIndex}
            submitShowError={submitShowError}
            showAllErrors={showAllErrors}
            formik = {formik}
            reactCount = {reactCount}

            />
          );
        })}
              <Button 
      disabled={reactCount >= 95}
      style={{ marginLeft: '500px', marginTop: 10 }}
      onClick={() => addNewSample()} variant="contained" color="primary">
        Add new sample
      </Button>
      </div>
      </Grid>
        <Grid item md={12} lg={3}>
          <div  style={{width: 340}}>
      <h1 style={{ fontSize: 32, marginBottom: 0}}>
        Primer Table
      </h1>
      <br></br>
        {Array.from(primers.keys()).map((key, i) => {
          // console.log(key)
          return (
              <SangerPrimerRowComponent
                  key={primers.get(key).id}
                  id={primers.get(key).id}
                  primerKey={key}
                  index={i}
                  data={primers.get(key)}
                  // key={primers.get(key).id[0]}
                  primers={primers}
                  primerMapToList={primerMapToList}
                  updatePrimerMap={updatePrimerMap}
                  removePrimer={removePrimer}
                  formik = {formik}
                  primerColors={primerColors}
                  showAllErrors={showAllErrors}
                  submitShowError={submitShowError}
                  reactCount={reactCount}
              />
          );
        })}

      <Button variant="contained" color="primary" onClick={() => addNewPrimer()}>
        Add primer
      </Button>
      <SangerLabPrimerPopup
      addNewLabPrimer={addNewLabPrimer}
      pickedLabPrimersMap={pickedLabPrimersMap}/>
      </div>
      </Grid>
      </Grid>
      <br></br>
      {/* <div style={{height: 50, width: 50}}>
      <FormikProvider value={formik}>
        {errors.samples}
        </FormikProvider>
      </div> */}

      <div style={{marginLeft: 'auto', marginRight: 'auto', padding: 20}}>
      <form onSubmit={formik.handleSubmit}>
        <LoadingButton
                  size="large"
                  // classes="profileSubmit"
                  // type="submit"
                  variant="outlined"
                  className={classes.submitButton}
                  onClick={handleErrorPopup}
                  disabled={samples.length == 0}
                  loading={isSubmitting}
                  loadingIndicator={
                    <RotateLoader
                      cssOverride={{ left: '100%' }}
                      size={7}
                      margin={-15}
                    />
                  }
                  >
        Submit
        </LoadingButton>
      </form>
      </div>
      </Grid>
    </div>
  );
};

export default Sanger;
